import type { SelectedTimeSlotType, TimeSlotType } from '~/model/TimeSlotType';
import { useState } from 'react';
import { fetchCollection } from '@/app/actions/server';
import { useContributorContext } from '../[locale]/(form)/components/provider/ContributorProvider';
import { useApiErrorContext } from '../components/Provider';

export function useTimeslots({
  timeslots,
  selectedTimeslots: baseSelectedTimeslots,
}: {
  timeslots: TimeSlotType[];
  selectedTimeslots?: SelectedTimeSlotType[];
}) {
  const { contributions } = useContributorContext();
  const { setError } = useApiErrorContext();

  const [isTimeslotsSubmitted, setIsTimeslotsSubmitted] = useState(!timeslots?.length);
  const [selectedTimeslots, setSelectedTimeslots] = useState<SelectedTimeSlotType[]>(baseSelectedTimeslots || []);

  const contributionId = contributions?.[0]?.id;

  const fetchSelectedTimeslots = async () => {
    const response = await fetchCollection<SelectedTimeSlotType>({
      pathname: `contributions/${contributionId}/selected_time_slots`,
      revalidate: 0,
      unpaginate: true,
    });

    if (response['hydra:description']) {
      return setError(response);
    }

    setSelectedTimeslots(response['hydra:member']);
  };

  return {
    isTimeslotsSubmitted,
    selectedTimeslots,
    timeslots,
    fetchSelectedTimeslots,
    setIsTimeslotsSubmitted,
    setSelectedTimeslots,
  };
}
